

const cardBodyStyle = {
  cardBody: {
    //padding: "40px 20px 10px 20px",
    flex: "1 1 auto",
    WebkitBoxFlex: "1",
    position: "relative",
    //backgroundImage: `url(${cenefa}) !important`,
    //backgroundRepeat: "repeat-x !important"
  },
  cardBodyPlain: {
    paddingLeft: "5px",
    paddingRight: "5px"
  },
  cardBodyProfile: {
    marginTop: "15px"
  }
};

export default cardBodyStyle;
